import { TaskPriority, TaskStatus } from "./task";

export const TASK_BULK_UPDATE_PROGRESS_SUBJECT = "task-bulk-update.progress";
export const TASK_SAVED_SUBJECT = "task.saved";
export const TASK_BULK_SAVED_SUBJECT = "task.bulk-saved";

export type TaskSavedEventKind = "created" | "updated";

export interface TaskSavedEvent {
    taskId: string;
    workspaceId: string;
    /** null when the change was made by the system (no acting user) */
    updatedByUserId: number | null;
    kind: TaskSavedEventKind;
}

export interface TaskBulkSavedEvent {
    taskIds: string[];
    workspaceId: string;
    /** null when the change was made by the system (no acting user) */
    updatedByUserId: number | null;
}

export interface TaskBulkUpdateProgressEvent {
    taskId: string;
    status?: TaskStatus;
    priority?: TaskPriority | null;
    assigneeId?: number | null;
    groupId?: string | null;
    entityIds?: number[];
}
